import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";

//console.clear();
/*
session
初回アクセスかどうか
*/

let isFirst = true;
const keyName = 'visited';
const keyValue = true;
const html = document.querySelector('html');


if (!sessionStorage.getItem(keyName)) {
  sessionStorage.setItem(keyName, keyValue);
  window.scroll({ top: 0 });
  html.classList.add('firstvisit');
} else {
  isFirst = false;
  html.classList.add('visited');
}


/*
デバイスのリサイズイベント取得
*/
let resizeEvent;
let isOrientationChangeSupported = 'onorientationchange' in window;
if (isOrientationChangeSupported) {
  resizeEvent = 'orientationchange';
} else {
  resizeEvent = 'resize';
}

/*
welcome
時間によって#loadingのメッセージを変更
*/
function welcome(element) {
  let now = new Date();
  let Hour = now.getHours();
  let el = document.querySelector(element);
  let welcomeTxt = '<span class="ib">今日は&nbsp;</span>';
  if (Hour > 0 && Hour <= 10) {
    welcomeTxt += '<span class="ib">どんな一日にしたいですか？</span>';
  } else if (Hour > 10 && Hour <= 16) {
    welcomeTxt += '<span class="ib">どんな一日ですか？</span>';
  } else {
    welcomeTxt += '<span class="ib">どんな一日でしたか？</span>';
  }
  el.innerHTML = welcomeTxt;
}
/*
split text
文字列をアニメーション用に分割
isFirst = true : #intro-msgと#splash-intro
isFirst = false : #splash-introのみ
*/
let count = 0;
let delay;
function splitTxt(parent) {
  if (isFirst) {
    if (count > 2) {
      return;
    }
  } else {
    if (count > 1) {
      return;
    }
  }
  const parentElm = document.querySelector(parent);
  const textboxes = document.querySelectorAll(parent + " span");
  const arr = [];
  for (var i = 0; i < textboxes.length; i++) {
    const textbox = textboxes[i];
    let content = textbox.textContent;
    arr.push(content);
    textbox.innerHTML = "";
  }
  let n = 0;
  arr.forEach((ar) => {
    ar.split("").forEach((e, index) => {
      delay = Math.round(index / 3 * 100) / 1000;
      if (n > 0) { delay += Math.round(n / 5 * 100) / 100; }
      textboxes[n].innerHTML +=
        '<span style="animation-delay:' + delay + 's;">' + e + "</span>";
    });
    n++;
  });
  parentElm.classList.add('show');
  count++;
}

/*
.gridLayerの各写真を表示
*/
function runGrid() {

  // let i = 1;
  let dly;
  let classes = ['grid1', 'grid2', 'grid3', 'grid4'];
  let isFV = false;
  // let gridtl;

  gsap.utils.toArray(".grid-layer").forEach((e, index) => {
    isFV = classes.some(function (className) { return e.classList.contains(className) });
    if (isFV) {
      dly = 0.5 + (index / 20);
    } else {
      dly = 0.2;
    }
    let dur = 1;

    gsap.timeline({
      scrollTrigger: {
        trigger: e,
        start: "top bottom+=200",
        end: 'bottom bottom',
      }
    })
      .set(e, { y: 'random(20,200)', autoAlpha: 0 })
      .to(e, { delay: dly, duration: dur, y: 0, autoAlpha: 1 })
  })
}


const elm = document.getElementById('centerLayer');
const triggerElement = document.querySelector('.splash-img');
const centerFigure = document.getElementById('centerImg');
const centerImage = centerFigure.querySelector('img');
const msg = document.querySelector('.page__index-welcome-msg-wrapper');
const copyright = document.querySelector('.splash__copyright');

let direction = 1;
let zoomtl;
let zoomtlBack;

/*
ズーム
*/

function zoom(direction) {
  let scale = 0;

  if (direction === 1) {
    copyright.classList.add('hide');
    zoomtl = gsap.timeline({
    })
      .add(() => {
        let calcBase = Math.max(window.innerWidth / elm.clientWidth, window.innerHeight / elm.clientHeight);
        scale = Math.round(calcBase * 100) / 100;
      })
      .to(triggerElement, {
        duration: 0.6,
        scale: () => scale
      })
      .to(centerFigure, {
        width: () => Math.round(window.innerWidth / scale) + 4,
        height: () => Math.round(window.innerHeight / scale) + 4,
      }, '<')
      .to(centerImage, {
        scale: () => {
          const windowAspectRatio = window.innerWidth / window.innerHeight;
          let imgCalcBase;
          if (window.innerWidth < window.innerHeight) { //ウィンドウが縦長
            imgCalcBase = window.innerHeight / elm.clientHeight;
          } else {
            if (windowAspectRatio >= 1.5) { //画像のaspect ratioと同じかそれ以上
              imgCalcBase = window.innerWidth / elm.clientWidth;
            } else {
              imgCalcBase = (window.innerHeight / elm.clientHeight) * windowAspectRatio;
            }
          }
        //  console.log(Math.round(((1 / imgCalcBase) + 0.005) * 100) / 100);
          return Math.round(((1 / imgCalcBase) + 0.005) * 100) / 100;
        }
      }, '<')
      .add(() => {
        msg.classList.add('show');
        html.classList.add('zoomed');
      })
  }

  if (direction === -1) {
    copyright.classList.remove('hide');
    zoomtlBack = gsap.timeline({
    })
      .add(() => {
        msg.classList.remove('show');
        html.classList.remove('zoomed');
      })
      .to(centerImage, {
        duration: 0.001,
        scale: () => 1 / (centerImage.clientHeight / elm.clientHeight)
      }, '<')
      .to(centerFigure, {
        duration: 0.01,
        width: () => '100%',
        height: () => '100%'
      }, '<')

      .to(triggerElement, {
        duration: 0.2,
        scale: 1,
      }, '<')
      .to(triggerElement, {
        autoAlpha: 1,
        duration: 0.4,
      })
  }
}

/*
ScrollTrigger
*/
let tl;

function runGsap() {
  let duration1 = 1;
  let duration2 = 3;

  tl = gsap.timeline({
    scrollTrigger: {
      trigger: () => triggerElement,
      pin: '.page__index-welcome-images',
      start: () => "center" + " center",
      end: () => window.innerHeight * 3,
      scrub: 1,
      invalidateOnRefresh: true,
      anticipatePin: 1,
      toggleActions: "play pause reverse pause",
      // markers: true,
      toggleClass: {
        targets: html,
        className: 'active',
      },
      onUpdate: self => {
        direction = self.direction;
        if (direction !== self.prevDirection) {
          self.prevDirection = direction;
          if (direction === 1) {
            duration1 = 1;
            duration2 = 3;
          }
          if (direction === -1) {
            duration1 = 3;
            duration2 = 1;
          }
        }
      },
    },
  }).set(triggerElement, {
    transformOrigin: () => {
      let base = Math.round(elm.offsetTop + (elm.clientHeight / 2));
      return 'center ' + base + 'px';
    },
  })
    .set(centerImage, {
      scale: () => {
        let calcBase = centerImage.clientHeight / elm.clientHeight;
        return Math.round(((1 / calcBase) + 0.005) * 100) / 100;
      },
      transformOrigin: 'center center'
    })
    .to(triggerElement, {
      autoAlpha: 1,
      duration: duration1,
    })
    .add(() => {
      zoom(direction);
    })
    .to(triggerElement, {
      autoAlpha: 1,
      duration: duration2,
    })

}


/*
DOM content loaded
*/

document.addEventListener('DOMContentLoaded', function () {
  if (isFirst) {
    welcome("#intro-msg");
  }
}, false);

function init() {
  runGrid();
  if (!html.classList.contains('init')) {
    html.classList.add('init');
  }
  runGsap();

}

function before_init() {
 
  splitTxt('#splash-msg');
  html.style.scrollBehavior = 'auto';
  gsap.registerPlugin(ScrollTrigger);
  gsap.defaults({ ease: "none" });
  gsap.config({ force3D: true });
  init();
}


/*
load
*/

//ローディング→gsapのタイミング用
let timer = 0;

window.addEventListener('load', function () {
  //html.classList.add('loaded');

  if (isFirst) {
    splitTxt("#intro-msg");
    clearTimeout(timer);
    timer = setTimeout(() => {
      before_init();
    }, 1800)
  } else {
    clearTimeout(timer);
    timer = setTimeout(() => {
      before_init();
      setTimeout(function () {
        clearTimeout(timer);
      }, 500);
    }, 10)
  }
});



/*
resize || orientation change
*/

function resizeStart() {
  triggerElement.style.opacity = 0.01;
  msg.style.opacity = 0;
  msg.classList.remove('show');
  html.classList.remove('zoomed');
  copyright.classList.remove('hide');
}

function refreshAll() {
  if (typeof tl !== 'undefined') {
    if (typeof zoomtlBack !== 'undefined') {
      zoomtlBack.pause();
    }
    if (typeof zoomtl !== 'undefined') {
      zoomtl.pause(0);
    }
    tl.pause(0).scrollTrigger.refresh();
  }
  triggerElement.style.opacity = 1;
  msg.style.opacity = 1;
}

let resizeTimer;

window.addEventListener(resizeEvent, function () {
  resizeStart();
  if (resizeTimer) clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    //console.log('resize end - refresh');
    refreshAll();
    setTimeout(function () {
      clearTimeout(resizeTimer);
     // console.log('end');
    }, 600);
  },200);
});
